import React, { useEffect } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { useDispatch, useSelector } from "react-redux";
import { fetchPrivacyPolicy } from "../../redux/slices/CommonSlice";
import bannerImage from "../../assets/images/Hero-section.png";
import HelmetBase from "../../components/HelmetBase";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { privacyPolicy } = useSelector((state) => state.commonStore);

  useEffect(() => {
    dispatch(fetchPrivacyPolicy());
  }, [dispatch]);

  return (
    <>
      <HelmetBase
        title={`${t("Privacy Policy")}`}
        name={`${t("Privacy Policy")}`}
      />
      <Navbar />
      <section
        className="hero-section2"
        id="home"
        style={{
          backgroundImage: privacyPolicy?.banner_image
            ? `url(${privacyPolicy?.banner_image})`
            : `url(${bannerImage})`,
        }}
      >
        <div className="container">
          <div className="hero-text">
            <h1>{privacyPolicy?.name}</h1>
          </div>
        </div>
      </section>
      <section className="about-section" id="about">
        <div className="container">
          <div className="row">
            <div
              className="col-sm-12 about-text"
              dangerouslySetInnerHTML={{ __html: privacyPolicy?.content }}
            ></div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
